import { render } from "./main_dashboard.vue?vue&type=template&id=415ffdc4"
import script from "./main_dashboard.vue?vue&type=script&lang=js"
export * from "./main_dashboard.vue?vue&type=script&lang=js"

import "./main_dashboard.vue?vue&type=style&index=0&id=415ffdc4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__